import React, { Component } from "react";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import {
  Button,

} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

const modalStyle = {
  width: '700px',
  height: '600px',
  marginLeft: '-10%',
  marginTop: '-20%',
}

const propTypes = {
  selectedRows: PropTypes.array,
  onSuccess: PropTypes.func,
}

const defaultProps = {
  onSuccess: () => { },
  selectedRows: [],
}

class AutoCodesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      selectedRows: [],
      currentRow: undefined,
    };
  }

  componentDidMount() {
    if (this.props.data) {
      this.setState({
        rows: ((this.props.data && this.props.data.autoCodes || [])).map((item, index) => {
          return { ...item, _id: index, pack_time: this.timeTOYmdOrMdy(item.pack_time, 'mm-dd-yyyy') }
        }),
        line: this.props.data,
        pack_time: this.props.data.package_date,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.setState({
        rows: (nextProps.data && nextProps.data.autoCodes || []).map((item, index) => {
          return { ...item, _id: index }
        }),
        line: this.props.data,
        pack_time: this.props.data.package_date,
      });
    }
  }

  handleConfirmClick = () => {
    const { line } = this.state;
    let confirmRows = [];
    let isEmpty = false;
    let isUselessDate = false;
    this.state.rows.map(item => {
      if(!item.prod_wt || !item.pack_time) {
        isEmpty = true;
        return
      }
      if(item.pack_time && item.pack_time.length != 10) {
        isUselessDate = true;
        return
      }
      confirmRows.push({
        prod_wt: parseFloat(item.prod_wt),
        prod_num: line.ProductNum,
        pack_time: this.timeTOYmdOrMdy(item.pack_time),
        prod_ref: item.prod_ref,
      })
    })
    if(isEmpty) {
      alert('Weight or date cannot be empty');
      return
    }
    if(isUselessDate) {
      alert('The date does not conform to the format');
      return
    }
    this.props.onConfirm(confirmRows, this.props.isNewPo ? line.uniqID : line.Batch_id);
  }

  moveCodeFromList = (idx) => {
    let newRows = [...this.state.rows];
    newRows = newRows.filter(obj => (
      obj.idx !== idx
    ));
    this.setState({ rows: newRows });
  }

  handleAddCode = () => {
    let rows = [...this.state.rows];
    const {pack_time} = this.state;
    const { line } = this.state;
    if (rows.length > 0) {
      let idIndex = rows.length;
      rows.push({
        _id: idIndex,
        prod_wt: 0,
        pack_time: pack_time,
        prod_ref: line.ProductRefNum,
      })
    } else {
      rows.push({
        _id: 0,
        prod_wt: 0,
        pack_time: pack_time,
        prod_ref: line.ProductRefNum,
      })
    }
    this.setState({ rows });
  }

  handlePrintCode = () => {
    let cpSelectedRows = [];
    const { line } = this.state;
    let noSave = false;
    this.state.selectedRows.map(item => {
      if (!item.prod_num || item.prod_wt == 0) {
        noSave = true;
        return
      }
      cpSelectedRows.push({
        prod_wt: item.prod_wt,
        prod_num: item.prod_num,
        pack_time: this.timeTOYmdOrMdy(item.pack_time),
        prod_ref: item.prod_ref,
        batch_id: line.Batch_id,
      })
    })
    if (noSave) {
      alert('Must be saved before printing');
      return
    }
    this.props.print(cpSelectedRows)

  }

  handleDeleteCode = () => {
    let cpSelected = [...this.state.selectedRows];
    let cpRows = [];
    this.state.rows.map((item, index) => {
      if (cpSelected.findIndex(select => select._id == index) == -1) {
        cpRows.push({ ...item });
      };
    })
    let rows = cpRows.map((item, index) => {
      return {...item, _id: index}
    })
    this.setState({ rows });
  }

  timeTOYmdOrMdy = (time, format = 'yyyy-mm-dd') => {
    let timeTo = time;
    if (time.length != 10 || time.indexOf('-') == -1) {
      return timeTo
    }
    if (format == 'yyyy-mm-dd') {// 12-12-2024 -> 2024-12-12
      if (time.length == 10 && time.indexOf('-') != -1) {
        let times = time.split('-');
        if(times[2].length != 4) {
          return timeTo;
        }
        timeTo = `${times[2]}-${times[0]}-${times[1]}`
      }
    }
    if (format == 'mm-dd-yyyy') {// 2024-12-12 -> 12-12-2024
      if (time.length == 10 && time.indexOf('-') != -1) {
        let times = time.split('-');
        if(times[0].length != 4) {
          return timeTo;
        }
        timeTo = `${times[1]}-${times[2]}-${times[0]}`
      }
    }
    return timeTo;
  }

  renderAutoCodesTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state);
    const getSize = () => getRows().length;
    const rowGetter = rowIdx => {
      var rows = getRows();
      return Object.assign({}, rows[rowIdx]);
    }

    const columns = [
      {
        key: 'pack_time',
        name: <Translate value="package_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'prod_wt',
        name: <Translate value="weight" />,
        resizable: true,
        editable: true,
        sortable: true,
        filterable: true,
      }
    ];

    const handleRowUpdated = (e) => {
      let rows = getRows();
      if (e.updated.prod_wt != null) {
        if (parseFloat(e.updated.prod_wt) < 0) {
          alert('The weight must be greater than 0');
        }
        Object.assign(rows[e.rowIdx], { prod_wt: e.updated.prod_wt });
        this.setState({ rows })
      }
    }

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      let selectedRows = [];
      rows.map(r => {
        newRows[r.rowIdx].isSelected = true;
      });

      newRows.map(r => {
        if (r.isSelected === true) {
          selectedRows.push(r);
        }
      });
      this.setState({ ...this.state, selectedRows, rows: newRows })

    };
    const onRowsDeselected = (rows) => {
      
      const newRows = [...this.state.rows];
      const selectedRows = [...this.state.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        const rowIndex = selectedRows.findIndex(item => item._id == r.row._id);
        selectedRows.splice(rowIndex, 1);
      });
      this.setState({ rows: newRows, selectedRows });
    };

    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        let rows = getRows();
        let selectedRows = [];
        rows.map(rowItem => {
          if (rowItem._id == row._id) {
            if (row.isSelected) {
              return { ...rowItem, isSelected: false };
            }
            selectedRows.push({ ...rowItem, isSelected: true });
            return { ...rowItem, isSelected: true };
          }
          if (rowItem.isSelected) {
            selectedRows.push({ ...rowItem });
          }
          return { ...row }
        })
        rows[rowIdx].isSelected = true;
        this.setState({ rows, selectedRows: [...this.state.selectedRows] });
      }
    };

    const onCellSelected = (row) => {
      const rows = getRows();
      let selectedRows = [];
      rows.map(rowItem => {
        if (rowItem._id == row.rowIdx) {
          if (rowItem.isSelected) {
            return { ...rowItem, isSelected: false };
          }
          selectedRows.push({ ...rowItem, isSelected: true });
          return { ...rowItem, isSelected: true };
        }
        if (rowItem.isSelected) {
          selectedRows.push({ ...rowItem });
        }
        return { ...row }
      })
      rows[row.rowIdx].isSelected = true;
      this.setState({ rows, selectedRows: [...this.state.selectedRows] });
    };

    return (
      <ReactDataGrid
        rowKey='autoCode'
        enableCellSelect={true}
        rowGetter={rowGetter}
        headerRowHeight={45}
        rowHeight={25}
        rowsCount={getSize()}
        columns={columns}
        onRowUpdated={handleRowUpdated}
        minHeight={450}
        enableRowSelect="multi"
        rowSelection={{
          showCheckbox: true,
          onRowsSelected,
          onRowsDeselected,
          selectBy: {
            isSelectedKey: 'isSelected',
          },
        }}
        onRowClick={onRowClick}
        onCellSelected={onCellSelected}
      />
    )
  }

  render() {

    return (
      <div style={{ width: '100%', height: '100%', padding: '10px' }}>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'start', alignContent: 'end', textAlign: 'end', alignItems: 'end', paddingBottom: '10px' }}>
          <Button
            bsStyle="success"
            className="print-btn"
            type="button"
            onClick={this.handleAddCode}
          >
            <Translate value="add" />
          </Button>
          {this.props.isCanPrint && <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            style={{ marginLeft: 10 }}
            disabled={this.state.selectedRows.length == 0 || this.state.selectedRows.findIndex(item => !item.prod_num) !=-1}
            onClick={this.handlePrintCode}
          >
            <Translate value="print" />
          </Button>}
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            style={{ marginLeft: 10 }}
            onClick={this.handleConfirmClick}
          >
            <Translate value="confirm" />
          </Button>
          <Button
            bsStyle="danger"
            className="print-btn"
            type="button"
            style={{ marginLeft: 10 }}
            disabled={this.state.selectedRows.length == 0}
            onClick={this.handleDeleteCode}
          >
            <Translate value="delete" />
          </Button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '350px', border: '1px olid red' }}>
          {this.renderAutoCodesTable()}
        </div>
      </div>
    )
  }
}

const AutoCodesModal = ({ setModalVisibility, isVisible, onConfirm, data, print, isCanPrint = true, isNewPo = false }) => (
  <SkyLightStateless
    title={<Translate value="long_codes" />}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <AutoCodesList onConfirm={onConfirm} isCanPrint={isCanPrint} data={data} isVisible={isVisible} print={print} isNewPo={isNewPo}/>
  </SkyLightStateless>
)

AutoCodesModal.propTypes = propTypes
AutoCodesModal.defaultProps = defaultProps

export default AutoCodesModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/warehouseManagement/AutoCodesModal.jsx